/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Selectors
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { IMultiBalance, IWidgetMultiBalancesReducer } from './widgetMultiBalancesTypes';

export const makeSelectWidgetMultiBalances = (state: IRootReducer): IWidgetMultiBalancesReducer =>
    state.dashboard.widgetMultiBalances;

/*
* -------------------------------------------
*           SEARCH VALUE
* -------------------------------------------
*/

export const makeSelectWidgetMultiBalancesList = ():
    OutputSelector<IRootReducer, IMultiBalance[], (state: IWidgetMultiBalancesReducer) => IMultiBalance[]> =>
    createSelector(makeSelectWidgetMultiBalances, (state) => state.list || []);
